import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import BackArrowIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "infrastructure/router";

const ApplicationDetailHeader = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                mt: -9
            }}
        >
            <Button
                variant='outlined'
                startIcon={<BackArrowIcon />}
                onClick={() => navigate('..')}
            >
                Back to Applications
            </Button>
        </Box>
    );
};

export default ApplicationDetailHeader;
